import {
	ClientFinancialPlanExpenseNameEnum,
	ClientFinancialPlanExpenseTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { z } from "zod";

export const expenseEntrySchema = z.object({
	id: z.number().nullable(),
	type: z.nativeEnum(ClientFinancialPlanExpenseTypeEnum),
	name: z.nativeEnum(ClientFinancialPlanExpenseNameEnum),
	monthlyPayment: z.number().min(0),
	sustainableAmount: z.number().min(0),
});

export type ExpenseFormEntry = z.infer<typeof expenseEntrySchema>;
